"use strict";

module.exports = {
  'name': 'sin',
  'category': 'Trigonometry',
  'syntax': ['sin(x)'],
  'description': 'Compute the sine of x in radians.',
  'examples': ['sin(2)', 'sin(pi / 4) ^ 2', 'sin(90 deg)', 'sin(30 deg)', 'sin(0.2)^2 + cos(0.2)^2'],
  'seealso': ['asin', 'cos', 'tan']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/trigonometry/sin.js
// module id = 974
// module chunks = 0